<template>
	<div v-if="notSupported" class="height-100 flex-centerize">
		<h2 class="reg">Ply doesn't support Add-ons for this app yet.</h2>
	</div>
	<div v-else class="width-100 height-100">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between pt-7 pr-6">
			<div>
				<div class="title-text">Features</div>
				<div class="description-text">Create custom pieces of software, anywhere. For your team or your customers</div>
			</div>
			<div v-if="filterWorkflowsIds.length > 0" @click="clearFilter" class="clear-filter">Clear filter</div>
			<div class="display-flex flex-row flex-align-center">
				<OpenInspirationCenterButton v-if="isInspirationCenterEnabled" />
				<AnemicButton v-if="canCreateNew" @click="$emit('show-wizard')" class="new-button ml-6">New Feature</AnemicButton>
			</div>
		</div>
		<FlowsView :page="page" :filterBy="filterBy" :idsToShow="filterWorkflowsIds" class="width-100 height-100 flows-container" />
	</div>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import FlowsView from '@/views/AppContentPages/FlowsView.vue';
import { setShowInspirationCenter } from '@/store/modules/appLayout/actions';
import OpenInspirationCenterButton from '@/components/dialogs/IdeaDialog/OpenInspirationCenterButton.vue';
import { isInspirationCenterEnabled } from '@/store/modules/featureFlags/getters';
export default {
	name: 'Features',
	props: {
		idsToShow: { type: Array },
		filterBy: { type: Object },
		notSupported: { type: Boolean },
		page: { type: Number, default: 1 },
		canCreateNew: { type: Boolean, default: true },
	},
	components: { FlowsView, OpenInspirationCenterButton },
	computed: {
		...mapGettersShorthand({ isInspirationCenterEnabled }),
	},
	methods: {
		...mapActionsShorthand({ setShowInspirationCenter }),
		showInspirationCenter() {
			this.setShowInspirationCenter({ showInspirationCenter: true });
		},
		clearFilter() {
			this.filterWorkflowsIds = [];
		},
	},
	mounted() {
		this.filterWorkflowsIds = this.idsToShow;
	},
	data() {
		return {
			filterWorkflowsIds: [],
		};
	},
};
</script>

<style scoped lang="scss">
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: var(--fifth-color) !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.flows-container {
	padding-bottom: 90px;
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: #a3a3a3;
	text-align: left;
	letter-spacing: 0px;
}
.clear-filter {
	font-size: 14px;
	opacity: 0.5;
	text-decoration: underline;
	cursor: pointer;
}
</style>
